import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback
} from "reactstrap";
import Joi from "joi-browser";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class ChangePassword extends React.Component {
  state = {
    user: {
       oldPassword:"",
       newPassword:"",
       confirmPassword:""
    },
   
    errors: {}
  };

  schema = Joi.object().keys({
    oldPassword: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Name is required."
        };
      }),
      newPassword: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Mobile Number is required."
        };
      }),
      confirmPassword: Joi.any()
      .valid(Joi.ref("newPassword"))
      .required()
      .error(errors => {
        return {
          message: "دونوں پاس ورڈ آپس میں نہیں ملتے۔ دوبارہ دیں"
        };
      })
   
  });


  reset = () => {
    let user = {
      oldPassword:"",
      newPassword:"",
      confirmPassword:""
    };

    let errors = {};
    this.setState({ user, errors });
  };

  // sign up validation
  validation() {
    let { error } = Joi.validate(this.state.user, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // handle change
  handleChange = event => {
    let value = event.target.value;
    let user = { ...this.state.user };
    user[event.target.name] = value;
    this.setState({ user });
  };

  // on submit
  handleSubmit = async event => {
    event.preventDefault();
    // validation
    let errors = this.validation();

    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let user = this.state.user;

    try {
      var { status } = await httpClient.put("/user/password", user);

      if (status === 200) {
        // show verification modal
        toast.success("پاس ورڈ کامیابی کے ساتھ اپ ڈیٹ ہوا", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.reset();
        this.props.toggle();
      
      }
    } catch (error) {
      // error occur
      
      
      let { status } = error.response;
      if (status === 400) {
        toast.info("پرانا پاس ورڈ غلط ہے", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      } else {
        toast.error(
        "پاس ورڈ تبدیل کرنے سے قاصر ، براہ کرم بعد میں کوشش کریں",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            transition: Slide
          }
        );
      }
    }
  };

  render() {
    let {  user, errors } = this.state;

    
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle}>
          <ModalHeader
            className="bg-info text-light"
            toggle={this.props.toggle}
          >
           پاس ورڈ تبدیل کریں
          </ModalHeader>
          <ModalBody>
            <Form>
             
              <FormGroup>
                <Label for="oldPassword">پرانا پاسورڈ</Label>
                <Input
                  type="password"
                  name="oldPassword"
                  id="oldPassword"
                  value={user["oldPassword"]}
                  placeholder="Old Password"
                  invalid={Boolean(errors["oldPassword"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
             
              <FormGroup>
                <Label for="newPassword">نیا پاس ورڈ</Label>
                <Input
                  type="password"
                  name="newPassword"
                  id="newPassword"
                  value={user["newPassword"]}
                  placeholder="New Password"
                  invalid={Boolean(errors["newPassword"])}
                  onChange={this.handleChange}
                />
              </FormGroup>

              <FormGroup>
                <Label for="confirmPassword">پاس ورڈ دوبارہ دیں</Label>
                <Input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  value={user["confirmPassword"]}
                  placeholder="Confirm Password"
                  invalid={Boolean(errors["confirmPassword"])}
                  onChange={this.handleChange}
                />
                 {errors["confirmPassword"] && (
                    <FormFeedback>{errors["confirmPassword"]}</FormFeedback>
                  )}
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.handleSubmit}>
            پاس ورڈ تبدیل کریں  
            </Button>
            <Button color="danger" onClick={this.props.toggle}>
              منسوخ کریں
            </Button>
          </ModalFooter>
        </Modal>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default ChangePassword;
